export enum BuilderInputType {
    currency = 'currency',
    credentials = 'credentials',
    client = 'client'
}
